import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import AAFModalError from '../../components/Modal/AAFModalError';
import AAFModalCheckEmail from '../../components/Modal/AAFModalCheckEmail';
import AAFModalResendEmail from '../../components/Modal/AAFModalResendEmail';
import AAFModalSuccessPTV from '../../components/Modal/AAFModalSuccessPTV';
import AAFModalSuccessPTVShort from '../../components/Modal/AAFModalSuccessPTVShort';
import AAFModalSentLink from '../../components/Modal/AAFModalSentLink';
import AAFModalActivate from '../../components/Modal/AAFModalActivate';
import AAFModalMonths from '../../components/Modal/AAFModalMonths';
import AAFModalYears from '../../components/Modal/AAFModalYears';
import AAFModalHubBidirectionalServices from '../../components/Modal/AAFModalHubBidirectionalServices';
import AAFModalStates from '../../components/Modal/AAFModalStates';
import AAFModalSuccess from '../../components/Modal/AAFModalSuccess';
import AAFModalSuccessSuscription from '../../components/Modal/AAFModalSuccessSuscription';
import AAFModalDocumentType from '../../components/Modal/AAFModalDocumentType';
import AAFModalService from '../../components/Modal/AAFModalService';
import AAFModalTelmexActivate from '../../components/Modal/AAFModalTelmexActivate';
import AAFModalChangePaymentMethod from '../../components/Modal/AAFModalChangePaymentMethod';
import AAFModalDeleteProfile from '../../components/Modal/AAFModalDeleteProfile';
import AAFModalPinInfo from '../../components/Modal/AAFModalPinInfo';
import AAFModalSuspendedAccount from '../../components/Modal/AAFModalSuspendedAccount';
import ModalDesconexion from '../../components/Modal/ModalDesconexion';
import ModalExit from '../../components/Modal/ModalExit';
import ModalPpe from '../../components/Modal/ModalPpe';
import ModalError from '../../components/Modal/ModalError';
import ModalErrorIpTelmex from '../../components/Modal/ModalErrorIpTelmex';
import ModalReintento from '../../components/Modal/ModalReintento';
import ModalAction from '../../components/Modal/ModalAction';
import ModalPin from '../../components/Modal/ModalPinCode'; // Antes ModalPinKeyboard';
import ModalPinCodeRecovery from '../../components/Modal/ModalPinCodeRecovery';
import ModalSuccess from '../../components/Modal/ModalSuccess';
import ModalReminderPin from '../../components/Modal/ModalReminderPin';
import ModalBorrarContenido from '../../components/Modal/ModalBorrarContenido';
import ModalAccionesContenido from '../../components/Modal/ModalAccionesContenido';
import ModalBorrarRecordatorio from '../../components/Modal/ModalBorrarRecordatorio';
import ModalAccionesRecordatorio from '../../components/Modal/ModalAccionesRecordatorio';
import ModalAccionesLenguaje from '../../components/Modal/ModalAccionesLenguaje';
import ModalMusicFilter from '../../components/Modal/ModalMusicFilter';
import ModalSocialLevel from '../../components/Modal/ModalSocialLevel';
import ModalLanguages from '../../components/Modal/ModalLanguages';
import ModalLanguagesLive from '../../components/Modal/ModalLanguagesLive';
import ModalFilterLive from '../../components/Modal/ModalFilterLive';
import ModalFilterLiveCategories from '../../components/Modal/ModalFilterLiveCategories';
import ModalOptionsEvent from '../../components/Modal/ModalOptionsEvent';
import ModalOptionsEpisodes from '../../components/Modal/ModalOptionsEpisodes';
import ModalEndPlayer from '../../components/Modal/ModalEndPlayer';
import ModalEndPlayer2 from '../../components/Modal/ModalEndPlayer2';
import ModalProfile from '../../components/Modal/ModalProfile';
import ModalAccionesCanales from '../../components/Modal/ModalAccionesCanales';
import ModalBorrarCanal from '../../components/Modal/ModalBorrarCanal';
import ModalConfirmPurchase from '../../components/Modal/ModalConfirmPurchase';
import ModalEpisodeSelect from '../../components/Modal/ModalEpisodeSelect';
import ModalGeneric from '../../components/Modal/ModalGeneric';
import { ModalTimeOutEventWithOnClose } from '../../components/Modal/ModalTimeOutEvent';
import ModalContextMenu from '../../components/Modal/ModalContextMenu';
import ModalDropDown from '../../components/Modal/ModalDropDown';
import ModalKeyboard from '../../components/Modal/ModalKeyboard';
import ModalAcceptTerm from '../../components/Modal/ModalAcceptTerm';
import ModalAcceptTermG3 from '../../components/Modal/ModalAcceptTermG3';
import ModalTermAndCond from '../../components/Modal/ModalTermAndCond';


import ModalPoliticas from '../../components/Modal/ModalPoliticas';
import ModalPoliticaPrivacidad from '../../components/Modal/ModalPoliticaPrivacidad';
import ModalTerminosCondiciones from '../../components/Modal/ModalTerminosCondiciones';
import ModalLicenciaUso from '../../components/Modal/ModalLicenciaUso';

import ModalPrivacy from '../../components/Modal/ModalPrivacy';
import ModalLicense from '../../components/Modal/ModalLicense';
import ModalUpdateEmail from '../../components/Modal/ModalUpdateEmail';
import ModalCountriesFilter from '../../components/Modal/ModalCountriesFilter';
import ModalCitiesFilter from '../../components/Modal/ModalCitiesFilter';
import ModalShowDetails from '../../components/Modal/ModalShowDetails';
import ModalRemoteControl from '../../components/Modal/ModalRemoteControl';
import ModalContextEpg from '../../components/Modal/ModalContextEpg';
import ModalContextChannels from '../../components/Modal/ModalContextChannels';
import ModalVersion from '../../components/Modal/ModalVersion';
import ModalRecordSeries from '../../components/Modal/ModalRecordSeries';
import ModalPromotion from '../../components/Modal/ModalPromotion';
import ModalRegisterNet from '../../components/Modal/ModalRegisterNet';
import ModalFilter from '../../components/Modal/ModalFilter';
import ModalDeleteTVChannel from '../../components/Modal/ModalDeleteTVChannel';
import ModalDeleteRecordings from '../../components/Modal/ModalDeleteRecordings';
import ModalDeleteFavorite from '../../components/Modal/ModalDeleteFavorite';
import ModalRecordSeriesContent from '../../components/Modal/ModalRecordSeriesContent';
import ModalChangingEpisode from '../../components/Modal/ModalChangingEpisode';
import ModalInactivity from '../../components/Modal/ModalInactivity';
import ModalEndPlayerCatchup from "../../components/Modal/ModalEndPlayerCatchup";
import AAFModalMundialCalendarioFase from "../../components/Modal/AAFModalMundialCalendarioFase";
import ModalEpgVersion from '../../components/Modal/ModalEpgVersion'
import AAFModalActualizaTusDatos2FA from '../../components/Modal/AAFModalActualizaTusDatos2FA';
import ExpiredCode2FA from '../../components/Modal/ExpiredCode2FA/ExpiredCode2FA';
import OnlineDebt from '../../components/Modal/OnlineDebt/OnlineDebt';
import Help2FA from '../../components/Modal/Help2FA/Help2FA';
import MatchDetailModal from '../../containers/Mundial2026/FootballMatchDetail/Components/MatchDetailModal/MatchDetailModal';
import CountryDetailsModal from '../../containers/Mundial2026/Paises/components/CountryDetailsModal';

import { bindActionCreators } from 'redux';
import { setMetricsEvent } from '../../actions/metrics';

import {
  AAF_MODAL_ERROR,
  AAF_MODAL_CHECK_EMAIL,
  AAF_MODAL_SUCCESS_PTV,
  AAF_MODAL_SUCCESS_PTV_SHORT,
  AAF_MODAL_SENT_LINK,
  AAF_MODAL_ACTIVATE,
  AAF_MODAL_MONTHS,
  AAF_MODAL_YEARS,
  AAF_MODAL_HUB_SERVICE,
  AAF_MODAL_STATES,
  AAF_MODAL_SUCCESS,
  AAF_MODAL_SUCCESS_SUSCRIPTION,
  AAF_MODAL_DOCUMENT_TYPE,
  AAF_MODAL_SERVICE_TYPE,
  AAF_MODAL_TEXLMEX_ACTIVATE,
  AAF_MODAL_CHANGE_PAYMENT_METHOD,
  AAF_MODAL_DELETE_PROFILE,
  AAF_MODAL_PIN_INFO,
  AAF_MODAL_SUSPENDED_ACCOUNT,
  MODAL_DESCONEXION,
  MODAL_EXIT,
  MODAL_PPE,
  MODAL_ERROR,
  MODAL_ERROR_IP_TELMEX,
  MODAL_REINTENTO,
  MODAL_ACTION,
  MODAL_PIN,
  MODAL_PIN_RECOVERY,
  MODAL_SOCIAL_LEVEL,
  MODAL_LANGUAGES,
  MODAL_LANGUAGES_LIVE,
  MODAL_FILTERS_LIVE,
  MODAL_FILTERS_LIVE_CATEGORIES,
  MODAL_OPTIONS_EVENT,
  MODAL_OPTIONS_EPISODES,
  MODAL_SUCCESS,
  MODAL_REMINDER_PIN,
  MODAL_BORRAR_CONTENIDO,
  MODAL_ACCIONES_CONTENIDO,
  MODAL_BORRAR_RECORDATORIO,
  MODAL_ACCIONES_RECORDATORIO,
  MODAL_CONFIRM_PURCHASE,
  MODAL_LANGUAGE,
  MODAL_MUSIC_FILTER,
  MODAL_PROFILE,
  MODAL_ACCIONES_CANALES,
  MODAL_BORRAR_CANAL,
  MODAL_EPISODE_SELECT,
  MODAL_GENERIC,
  MODAL_END_PLAYER,
  MODAL_END_PLAYER2,
  MODAL_TIMEOUT_EVENT,
  MODAL_MUSIC_CONTEXTUAL_MENU,
  MODAL_DROPDOWN,
  MODAL_KEYBOARD,
  MODAL_ACCEPT_TERM,
  MODAL_ACCEPT_TERMG3,
  MODAL_TERM_AND_COND,
  MODAL_POLITICAS,
  MODAL_POLITICA_DE_PRIVACIDAD,
  MODAL_TERMINOS_Y_CONDICIONES,
  MODAL_LICENCIA_DE_USO,
  MODAL_LICENSE,
  MODAL_PRIVACY,
  MODAL_UPDATE_EMAIL,
  MODAL_COUNTRIES_FILTER,
  MODAL_CITIES_FILTER,
  MODAL_SHOW_DETAILS,
  MODAL_REMOTE_CONTROL,
  MODAL_EPG,
  MODAL_CHANNEL_EPG,
  MODAL_VERSION,
  MODAL_RECORD_SERIES,
  MODAL_PROMOTION_TELMEX_TELCEL,
  MODAL_REGISTER_NET,
  MODAL_PURCHASE_SERIE,
  MODAL_FILTER,
  AAF_MODAL_RESEND_EMAIL,
  MODAL_DELETE_TV_CHANNEL,
  MODAL_DELETE_RECORDINGS,
  MODAL_DELETE_FAVORITE,
  MODAL_CALL_CENTER,
  MODAL_ADDON,
  MODAL_RECORD_SERIES_CONTENT,
  MODAL_CHANGING_EPISODE,
  MODAL_DELETE_LAST_SEEN,
  MODAL_DEVICES_EXCEEDED,
  MODAL_SEASON_SELECTOR,
  MODAL_TALENT_CONTENTS,
  AAF_MODAL_PROFILE,
  AAF_MODAL_PLAY_OPTIONS,
  AAF_MODAL_CALENDAR_PHASE,
  MODAL_MATCH_DETAIL,
  MODAL_COUNTRY_DETAILS,
  MODAL_END_PLAYER_CATCHUP,
  MODAL_INACTIVITY,
  MODAL_KEEP_WATCHING,
  AAF_MODAL_LANDING_STB,
  MODAL_ACTUALIZATION_EPGVERSION,
  MODAL_FAIL_FILTER_TALENTS,
  AAF_MODAL_HBO_PLAYBACK_ERROR,
  AAF_MODAL_ACTUALIZA_TUS_DATOS_2FA,
  MODAL_2FA_ONLINE_DEBT,
  MODAL_2FA_REMEMBER_CONFIRM_PURCHASE,
  MODAL_2FA_LIMIT_PURCHASES,
  MODAL_2FA_LIMIT_ATTEMPTS,
  AAF_MODAL_CONFIRM_PURCHASE_60_SECONDS,
  MODAL_2FA_EXPIRED_CODE,
  MODAL_ONLINE_DEBT,
  MODAL_HELP_2FA,
  AAF_MODAL_QR_LOGIN,
  AAF_MODAL_QR_PAYMENTS,
  AAF_MODAL_TELMEX_MESSAGE_METHOD_PAYMENT,
  AAF_MODAL_ACTIVA_HBO_MAX_QR,
  AAF_MODAL_INICIAL_ACTIVA_HBO_MAX,
  AAF_MODAL_PROMOCION_ACTIVA_HBO_MAX,
  AAF_MODAL_CHANGE_AAF_TO_CLARO_TV,
  MODAL_RATING_CONTENT
} from '../../actions/modal';
import ModalPurchaseSerie from '../../components/Modal/ModalPurchaseSerie';
import ModalDevicesExceeded from '../../components/Modal/ModalDevicesExceeded';
import ModalSeasonSelector from '../../components/Modal/ModalSeasonSelector';
import ModalTalentContents from '../../components/Modal/ModalTalentContents';
import AAFModalCallCenter from '../../components/Modal/AAFModalCallCenter';
import ModalDeleteLastSeen from '../../components/Modal/ModalDeleteLastSeen';
import AAFModalProfile from '../../components/Modal/AAFModalProfile';
import AAFModalPlayOptions from '../../components/Modal/AAFModalPlayOptions';
import ModalAddOn from '../../components/Modal/ModalAddOn';
import ModalKeepWatching from '../../components/Modal/ModalKeepWatching';
import AAFModalLandingSTB from '../../components/Modal/AAFModalLandingSTB';
import ModalFailFilterTalents from 'src/components/Modal/ModalFailFilterTalents';
import {
  AAFModalHBOPlaybackError
} from "../../components/Modal/AAFModalHBOPlaybackError";
import AAFModalRememberConfirmPurchase from '../../components/Modal/AAFModalRememberConfirmPurchase2FA';
import AAFModalLimitPuchases from '../../components/Modal/AAFModalLimitPurchases2FA';
import AAFModalLimitAttempts from '../../components/Modal/AAFModalLimitAttempts2FA';
import AAFModalQRPayments from '../../components/Modal/AAFModalQrPayments';
import AAFModalConfirmPurchase60Seconds2FA from "../../components/Modal/AAFModalConfirmPurchase60Seconds2FA";
import LoginQR from '../../components/Modal/LoginQR/LoginQR';
import AAFModalTelmexMessageMethodPayment from "../../components/Modal/Telmex/AAFModalTelmexMessageMethodPayment";
import AAFModalActivaHBOMaxQR from "../../components/Modal/ActivaHBOMaxQR/AAFModalActivaHBOMaxQR";
import AAFModalInicialActivaHBOMax from "../../components/Modal/ActivaHBOMaxQR/AAFModalInicialActivaHBOMax";
import AAFModalPromocionActivaHBOMax from "../../components/Modal/ActivaHBOMaxQR/AAFModalPromocionActivaHBOMax";
import AAFModalChangeAAFToClaroTV from "src/components/Modal/ModalChangeAAFToClaroTV/ModalChangeAAFToClaroTV";
import RatingContent from '../../components/Modal/ratingContent/RatingContent';


const MODAL_COMPONENTS = (() => {
    const components = {};
    //AAF New Modals
    components[AAF_MODAL_LANDING_STB] = AAFModalLandingSTB;
    components[AAF_MODAL_ERROR] = AAFModalError;
    components[AAF_MODAL_CHECK_EMAIL] = AAFModalCheckEmail;
    components[AAF_MODAL_RESEND_EMAIL] = AAFModalResendEmail;
    components[AAF_MODAL_SUCCESS_PTV] = AAFModalSuccessPTV;
    components[AAF_MODAL_SUCCESS_PTV_SHORT] = AAFModalSuccessPTVShort;
    components[AAF_MODAL_SENT_LINK] = AAFModalSentLink;
    components[AAF_MODAL_ACTIVATE] = AAFModalActivate;
    components[AAF_MODAL_MONTHS] = AAFModalMonths;
    components[AAF_MODAL_YEARS] = AAFModalYears;
    components[AAF_MODAL_HUB_SERVICE] = AAFModalHubBidirectionalServices;
    components[AAF_MODAL_STATES] = AAFModalStates;
    components[AAF_MODAL_SUCCESS] = AAFModalSuccess;
    components[AAF_MODAL_SUCCESS_SUSCRIPTION] = AAFModalSuccessSuscription;
    components[AAF_MODAL_DOCUMENT_TYPE] = AAFModalDocumentType;
    components[AAF_MODAL_SERVICE_TYPE] = AAFModalService;
    components[AAF_MODAL_TEXLMEX_ACTIVATE] = AAFModalTelmexActivate;
    components[AAF_MODAL_CHANGE_PAYMENT_METHOD] = AAFModalChangePaymentMethod;
    components[AAF_MODAL_DELETE_PROFILE] = AAFModalDeleteProfile;
    components[AAF_MODAL_PIN_INFO] = AAFModalPinInfo;
    // Normal Modals
    components[MODAL_DESCONEXION] = ModalDesconexion;
    components[MODAL_EXIT] = ModalExit;
    components[MODAL_PPE] = ModalPpe;
    components[MODAL_ERROR] = ModalError;
    components[MODAL_ERROR_IP_TELMEX] = ModalErrorIpTelmex;
    components[MODAL_REINTENTO] = ModalReintento;
    components[MODAL_ACTION] = ModalAction;
    components[MODAL_PIN] = ModalPin;
    components[MODAL_PIN_RECOVERY] = ModalPinCodeRecovery;
    components[MODAL_PURCHASE_SERIE] = ModalPurchaseSerie;
    components[MODAL_SUCCESS] = ModalSuccess;
    components[MODAL_REMINDER_PIN] = ModalReminderPin;
    components[MODAL_SOCIAL_LEVEL] = ModalSocialLevel;
    components[MODAL_LANGUAGES] = ModalLanguages;
    components[MODAL_LANGUAGES_LIVE] = ModalLanguagesLive;
    components[MODAL_FILTERS_LIVE] = ModalFilterLive;
    components[MODAL_FILTERS_LIVE_CATEGORIES] = ModalFilterLiveCategories;
    components[MODAL_OPTIONS_EVENT] = ModalOptionsEvent;
    components[MODAL_OPTIONS_EPISODES] = ModalOptionsEpisodes;
    components[MODAL_BORRAR_CONTENIDO] = ModalBorrarContenido;
    components[MODAL_ACCIONES_CONTENIDO] = ModalAccionesContenido;
    components[MODAL_BORRAR_RECORDATORIO] = ModalBorrarRecordatorio;
    components[MODAL_ACCIONES_RECORDATORIO] = ModalAccionesRecordatorio;
    components[MODAL_CONFIRM_PURCHASE] = ModalConfirmPurchase;
    components[MODAL_LANGUAGE] = ModalAccionesLenguaje;
    components[MODAL_MUSIC_FILTER] = ModalMusicFilter;
    components[MODAL_PROFILE] = ModalProfile;
    components[MODAL_ACCIONES_CANALES] = ModalAccionesCanales;
    components[MODAL_BORRAR_CANAL] = ModalBorrarCanal;
    components[MODAL_EPISODE_SELECT] = ModalEpisodeSelect;
    components[MODAL_GENERIC] = ModalGeneric;
    components[MODAL_END_PLAYER] = ModalEndPlayer;
    components[MODAL_END_PLAYER2] = ModalEndPlayer2;
    components[MODAL_TIMEOUT_EVENT] = ModalTimeOutEventWithOnClose;
    components[MODAL_MUSIC_CONTEXTUAL_MENU] = ModalContextMenu;
    components[MODAL_DROPDOWN] = ModalDropDown;
    components[MODAL_KEYBOARD] = ModalKeyboard;
    components[MODAL_ACCEPT_TERM] = ModalAcceptTerm;
    components[MODAL_ACCEPT_TERMG3] = ModalAcceptTermG3;
    components[MODAL_TERM_AND_COND] = ModalTermAndCond;
    components[MODAL_POLITICAS] = ModalPoliticas;
    components[MODAL_POLITICA_DE_PRIVACIDAD] = ModalPoliticaPrivacidad;
    components[MODAL_TERMINOS_Y_CONDICIONES] = ModalTerminosCondiciones;
    components[MODAL_LICENCIA_DE_USO] = ModalLicenciaUso;
    components[MODAL_PRIVACY] = ModalPrivacy;
    components[MODAL_LICENSE] = ModalLicense;
    components[MODAL_UPDATE_EMAIL] = ModalUpdateEmail;
    components[MODAL_COUNTRIES_FILTER] = ModalCountriesFilter;
    components[MODAL_CITIES_FILTER] = ModalCitiesFilter;
    components[MODAL_REMOTE_CONTROL] = ModalRemoteControl;
    components[MODAL_SHOW_DETAILS] = ModalShowDetails;
    components[MODAL_EPG] = ModalContextEpg;
    components[MODAL_CHANNEL_EPG] = ModalContextChannels;
    components[MODAL_VERSION] = ModalVersion;
    components[MODAL_RECORD_SERIES] = ModalRecordSeries;
    components[MODAL_PROMOTION_TELMEX_TELCEL] = ModalPromotion;
    components[MODAL_REGISTER_NET] = ModalRegisterNet;
    components[MODAL_FILTER] = ModalFilter;
    components[MODAL_DELETE_TV_CHANNEL] = ModalDeleteTVChannel;
    components[MODAL_DELETE_RECORDINGS] = ModalDeleteRecordings;
    components[MODAL_DELETE_FAVORITE] = ModalDeleteFavorite;
    components[MODAL_CALL_CENTER] = AAFModalCallCenter;
    components[AAF_MODAL_SUSPENDED_ACCOUNT] = AAFModalSuspendedAccount;
    components[MODAL_ADDON] = ModalAddOn;
    components[MODAL_RECORD_SERIES_CONTENT] = ModalRecordSeriesContent;
    components[MODAL_CHANGING_EPISODE] = ModalChangingEpisode;
    components[MODAL_DELETE_LAST_SEEN] = ModalDeleteLastSeen;
    components[MODAL_DEVICES_EXCEEDED] = ModalDevicesExceeded;
    components[MODAL_SEASON_SELECTOR] = ModalSeasonSelector;
    components[MODAL_TALENT_CONTENTS] = ModalTalentContents;
    components[AAF_MODAL_PROFILE] = AAFModalProfile;
    components[AAF_MODAL_PLAY_OPTIONS] = AAFModalPlayOptions;
    components[AAF_MODAL_CALENDAR_PHASE] = AAFModalMundialCalendarioFase;
    components[MODAL_MATCH_DETAIL] = MatchDetailModal;
    components[MODAL_COUNTRY_DETAILS] = CountryDetailsModal;
    components[MODAL_END_PLAYER_CATCHUP] = ModalEndPlayerCatchup;
    components[MODAL_INACTIVITY] = ModalInactivity;
    components[MODAL_KEEP_WATCHING] = ModalKeepWatching;
    components[MODAL_FAIL_FILTER_TALENTS] = ModalFailFilterTalents;

    components[MODAL_ACTUALIZATION_EPGVERSION] = ModalEpgVersion;
    components[AAF_MODAL_HBO_PLAYBACK_ERROR] = AAFModalHBOPlaybackError;
    components[MODAL_2FA_REMEMBER_CONFIRM_PURCHASE] = AAFModalRememberConfirmPurchase;
    components[MODAL_2FA_LIMIT_PURCHASES] = AAFModalLimitPuchases;
    components[MODAL_2FA_LIMIT_ATTEMPTS] = AAFModalLimitAttempts;

    components[AAF_MODAL_ACTUALIZA_TUS_DATOS_2FA] = AAFModalActualizaTusDatos2FA;
    components[AAF_MODAL_CONFIRM_PURCHASE_60_SECONDS] = AAFModalConfirmPurchase60Seconds2FA;
    components[MODAL_2FA_EXPIRED_CODE] = ExpiredCode2FA
    components[MODAL_ONLINE_DEBT] = OnlineDebt
    components[MODAL_HELP_2FA] = Help2FA
    components[AAF_MODAL_QR_LOGIN] = LoginQR;
    components[AAF_MODAL_QR_PAYMENTS] = AAFModalQRPayments

    components[AAF_MODAL_TELMEX_MESSAGE_METHOD_PAYMENT] = AAFModalTelmexMessageMethodPayment

    components[AAF_MODAL_ACTIVA_HBO_MAX_QR] = AAFModalActivaHBOMaxQR
    components[AAF_MODAL_INICIAL_ACTIVA_HBO_MAX] = AAFModalInicialActivaHBOMax
    components[AAF_MODAL_PROMOCION_ACTIVA_HBO_MAX] = AAFModalPromocionActivaHBOMax

    components[AAF_MODAL_CHANGE_AAF_TO_CLARO_TV] = AAFModalChangeAAFToClaroTV;
    components[MODAL_RATING_CONTENT] = RatingContent

  return components;
})();

class ModalConductor extends PureComponent {
    constructor(props) {
        super(props);
        this.isHidden = true;
        this.history = (props && props.history) || null;
        this.getLinks = (props && props.getLinks) || null;
        this.toggleVisibilityStatus = this.toggleVisibilityStatus.bind(this);
    }

    toggleVisibilityStatus() {
        this.isHidden = !this.isHidden;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return JSON.stringify(nextProps) !== JSON.stringify(this.props) || this.isHidden;
    }

    render() {
        const { modalType, modalProps } = this.props;
        if (!modalType || !MODAL_COMPONENTS[modalType]) return null;
        this.toggleVisibilityStatus();
        const Modal = MODAL_COMPONENTS[modalType];
        return (
            <Modal
                {...modalProps}
                toggleVisibilityStatus={this.toggleVisibilityStatus}
                setMetricsEvent={this.props.setMetricsEvent}
                history={this.history}
                getLinks={this.getLinks}
            />
        );
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setMetricsEvent,
        },
        dispatch
    );

export default connect((state) => state.modal, mapDispatchToProps)(ModalConductor);



// WEBPACK FOOTER //
// ./src/containers/Modal/index.jsx